/**
 * @generated SignedSource<<73326f969895433d7005938e7417424e>>
 * @relayHash 59320f1b8601c0164d05458b5671082b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7db8c3153986b4dbb13acf7de34310f81ac9a8e0ac042516b4ef9dcad70cc31e

import type { ConcreteRequest, Query } from 'relay-runtime';
export type PagesDisplayPersistenceOption = "CARDS" | "COMPACT_LIST" | "LIST" | "%future added value";
export type PagesSortField = "LAST_MODIFIED_DATE" | "RELEVANT" | "TITLE" | "%future added value";
export type PagesSortOrder = "ASC" | "DESC" | "%future added value";
export type SpacePagesPersistenceQueriesQuery$variables = {
  spaceKey: string;
};
export type SpacePagesPersistenceQueriesQuery$data = {
  readonly userPreferences: {
    readonly globalPageCardAppearancePreference: PagesDisplayPersistenceOption;
    readonly spacePagesSortView: {
      readonly field: PagesSortField;
      readonly order: PagesSortOrder;
    };
  } | null | undefined;
};
export type SpacePagesPersistenceQueriesQuery = {
  response: SpacePagesPersistenceQueriesQuery$data;
  variables: SpacePagesPersistenceQueriesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "concreteType": "UserPreferences",
    "kind": "LinkedField",
    "name": "userPreferences",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "globalPageCardAppearancePreference"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "spaceKey",
            "variableName": "spaceKey"
          }
        ],
        "concreteType": "PagesSortPersistenceOption",
        "kind": "LinkedField",
        "name": "spacePagesSortView",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "field"
          },
          {
            "kind": "ScalarField",
            "name": "order"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SpacePagesPersistenceQueriesQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SpacePagesPersistenceQueriesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "59320f1b8601c0164d05458b5671082b",
    "id": "7db8c3153986b4dbb13acf7de34310f81ac9a8e0ac042516b4ef9dcad70cc31e",
    "metadata": {},
    "name": "SpacePagesPersistenceQueriesQuery",
    "operationKind": "query",
    "text": "query SpacePagesPersistenceQueriesQuery($spaceKey:String!){userPreferences{globalPageCardAppearancePreference,spacePagesSortView(spaceKey:$spaceKey){field,order}}}"
  }
};
})();

(node as any).hash = "2a6df4b92cf1482402557b6fd5bb750a";

export default node;
